import { render, staticRenderFns } from "./SettingsPaymentChannel.vue?vue&type=template&id=5f732c00&"
import script from "./SettingsPaymentChannel.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports